export default __webpack_public_path__ + "static/Tek_Bridge-012f7b5a3adf543403e7a96705795a7e.png";